import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Stack,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CallIcon from '@mui/icons-material/Call';
import MessageIcon from '@mui/icons-material/Message';
import EmailIcon from '@mui/icons-material/Email';

interface ContactDialogProps {
  open: boolean;
  onClose: () => void;
}

const ContactDialog = ({ open, onClose }: ContactDialogProps) => {
  const handleCall = () => {
    window.location.href = 'tel:+12059730007';
    onClose();
  };

  const handleText = () => {
    window.location.href = 'sms:+12059730007';
    onClose();
  };

  const handleEmail = () => {
    window.location.href = 'mailto:hello@homepoint.co';
    onClose();
  };

  const outlinedButtonSx = {
    bgcolor: 'white',
    color: '#269af1',
    border: '2px solid #269af1',
    borderRadius: '50px',
    px: 3,
    py: 2,
    fontSize: { xs: 16, md: 18 },
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      bgcolor: 'rgba(38, 154, 241, 0.05)',
      transform: 'translateY(-2px)',
    },
    transition: 'all 0.2s ease',
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: { xs: 2, md: 3 },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            fontSize: { xs: 22, md: 26 },
            color: '#000',
          }}
        >
          Contact Us
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#666',
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography
          sx={{
            color: '#666',
            fontSize: { xs: 16, md: 18 },
            mb: 3,
            textAlign: 'center',
          }}
        >
          Choose how you'd like to reach us
        </Typography>

        <Stack spacing={2}>
          <Button
            onClick={handleCall}
            startIcon={<CallIcon />}
            fullWidth
            sx={{
              bgcolor: '#269af1',
              color: 'white',
              borderRadius: '50px',
              px: 3,
              py: 2,
              fontSize: { xs: 16, md: 18 },
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0 4px 12px rgba(38, 154, 241, 0.3)',
              '&:hover': {
                bgcolor: '#1e7dc1',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(38, 154, 241, 0.4)',
              },
              transition: 'all 0.2s ease',
            }}
          >
            Call (205) 973-0007
          </Button>

          <Button
            onClick={handleText}
            startIcon={<MessageIcon />}
            fullWidth
            sx={outlinedButtonSx}
          >
            Text (205) 973-0007
          </Button>

          <Button
            onClick={handleEmail}
            startIcon={<EmailIcon />}
            fullWidth
            sx={outlinedButtonSx}
          >
            Email hello@homepoint.co
          </Button>
        </Stack>

        <Typography
          sx={{
            mt: 3,
            color: '#999',
            fontSize: 14,
            textAlign: 'center',
            fontStyle: 'italic',
          }}
        >
          No pressure, just answers and insight.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ContactDialog;
